import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslationType } from '../../models/translation-type';

export const FILTERS_TRANSLATE_DASHBOARD_ACTIONS = {
  SET_TRANSLATION_TYPES: 'SET_TRANSLATION_TYPES'
};

export interface IFiltersTranslateDashboard {
  translationTypes: TranslationType[];
}

@Injectable()
export class FiltersTranslateDashboard {

  constructor(private store: Store<IFiltersTranslateDashboard>) { }

  setTranslationTypes(translationTypes: TranslationType[]) {
    this.store.dispatch({ type: FILTERS_TRANSLATE_DASHBOARD_ACTIONS.SET_TRANSLATION_TYPES, payload: { translationTypes } });
  }
}



// WEBPACK FOOTER //
// ./src/app/store/actions/filters-translate-dashboard.actions.ts